import * as React from "react";
import Cookies from "universal-cookie";

export default () => {
  return React.useMemo(() => new Cookies(), []);
};
